import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { supabase } from '../../../lib/supabase';

const ManagerSidebar = ({ collapsed, onToggle, managerName }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [unreadCount, setUnreadCount] = useState(0);
  const [profile, setProfile] = useState(null);
  const intervalRef = useRef(null);

  const currentMonthCap = t('months.' + new Date().getMonth());

  const navItems = [
    {
      label: t('nav.dashboard'),
      path: '/manager/dashboard',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <rect x="1" y="1" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
          <rect x="10" y="1" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
          <rect x="1" y="10" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
          <rect x="10" y="10" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      ),
    },
    {
      label: t('nav.creators'),
      path: '/manager/creators',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <circle cx="9" cy="6" r="3.5" stroke="currentColor" strokeWidth="1.5" />
          <path d="M2 16c0-3.314 3.134-6 7-6s7 2.686 7 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      ),
    },
    {
      label: t('nav.sessions', 'Sessions LIVE'),
      path: '/manager/sessions',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.9 19.1C1 15.2 1 8.8 4.9 4.9"/><path d="M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5"/><circle cx="12" cy="12" r="2"/><path d="M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5"/><path d="M19.1 4.9C23 8.8 23 15.1 19.1 19"/></svg>
      ),
    },
    {
      label: t('nav.recruitment', 'Recrutement'),
      path: '/manager/recruitment',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <circle cx="7" cy="6" r="3" stroke="currentColor" strokeWidth="1.5" />
          <path d="M1 16c0-3 2.7-5.5 6-5.5s6 2.5 6 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M14 4v4M12 6h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      ),
    },
    {
      label: t('nav.events', 'Match OFF & Tournois'),
      path: '/manager/events',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M9 1L2 5v6l7 4 7-4V5L9 1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
          <path d="M5.5 9l2.5 2.5 4-4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
    },
    {
      label: t('nav.tournaments', 'Tournois'),
      path: '/manager/tournaments',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M9 1l2 3h4l-3 3 1 4-4-2-4 2 1-4-3-3h4l2-3z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
          <path d="M4 14h10" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
          <path d="M6 14v2h6v-2" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
        </svg>
      ),
    },
    {
      label: 'Lark Matches',
      path: '/manager/lark',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M3 5h12M3 9h8M3 13h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <circle cx="15" cy="13" r="2" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
    },
    {
      label: 'Performance ' + currentMonthCap,
      path: '/manager/performance',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <circle cx="9" cy="9" r="7" stroke="currentColor" strokeWidth="1.5" />
          <path d="M9 5v4l3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
    },
    {
      label: t('nav.history', 'Historique Mensuel'),
      path: '/manager/performances',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <polyline points="2,13 6,8 10,10 16,4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="12,4 16,4 16,8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
    },
    {
      label: t('nav.payments', 'Ma Caisse'),
      path: '/manager/payments',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <rect x="1" y="3" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" />
          <path d="M1 7h16" stroke="currentColor" strokeWidth="1.5" />
          <circle cx="9" cy="11" r="2" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      ),
    },
    {
      label: t('nav.ai'),
      path: '/manager/ai',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M9 2C5.134 2 2 5.134 2 9s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7z" stroke="currentColor" strokeWidth="1.5" />
          <path d="M6 9l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
    },
    {
      label: t('nav.notifications'),
      path: '/manager/notifications',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M9 2a5 5 0 00-5 5v3l-1.5 2.5h13L14 10V7a5 5 0 00-5-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
          <path d="M7 14.5a2 2 0 004 0" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      ),
    },
    {
      label: t('nav.violations', 'Violations'),
      path: '/manager/violations',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M9 2L1.5 16h15L9 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
          <path d="M9 7v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="9" cy="13" r="0.5" fill="currentColor" />
        </svg>
      ),
    },
    {
      label: t('nav.profile'),
      path: '/manager/profile',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <circle cx="9" cy="6.5" r="3" stroke="currentColor" strokeWidth="1.5" />
          <path d="M3 15.5c0-2.761 2.686-5 6-5s6 2.239 6 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      ),
    },
  ];

  /* ── Tools section items ── */
  const toolsItems = [
    {
      label: t('nav.tools_poster'),
      path: '/manager/tools/poster',
      icon: (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <rect x="2" y="1" width="14" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
          <circle cx="9" cy="7" r="2.5" stroke="currentColor" strokeWidth="1.5" />
          <path d="M5 13h8M6 15.5h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      ),
    },
  ];

  const fetchUnreadCount = async () => {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) return;
      const { count } = await supabase?.from('notifications')?.select('*', { count: 'exact', head: true })?.eq('target_manager_id', user?.id)?.is('read_at', null);
      setUnreadCount(count || 0);
    } catch (e) {}
  };

  const fetchProfile = async () => {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) return;
      const { data: profileData } = await supabase?.from('users')?.select('name, email, role, is_paid, responsible_servers')?.eq('id', user?.id)?.single();
      setProfile(profileData);
    } catch (e) {}
  };

  useEffect(() => {
    fetchUnreadCount();
    fetchProfile();
    intervalRef.current = setInterval(fetchUnreadCount, 30000);
    return () => clearInterval(intervalRef?.current);
  }, []);

  const handleLogout = async () => {
    await supabase?.auth?.signOut();
    navigate('/login-authentication');
  };

  const isActive = (path) => location?.pathname === path;

  const getInitials = (n) => {
    if (!n) return '?';
    const parts = n?.trim()?.split(' ');
    if (parts?.length >= 2) return (parts?.[0]?.charAt(0) + parts?.[1]?.charAt(0))?.toUpperCase();
    return n?.trim()?.charAt(0)?.toUpperCase();
  };

  /* ── Render a single nav item ── */
  const renderItem = (item) => {
    const active = isActive(item?.path);
    const isNotifications = item?.path === '/manager/notifications';

    return (
      <button
        key={item?.path}
        onClick={() => navigate(item?.path)}
        className="w-full flex items-center gap-3 px-4 py-2.5 text-left transition-all duration-150 group relative"
        style={{ backgroundColor: active ? 'rgba(229,32,42,0.08)' : 'transparent', color: active ? '#E5202A' : 'rgba(255,255,255,0.45)' }}
        onMouseEnter={(e) => { if (!active) e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.04)'; }}
        onMouseLeave={(e) => { if (!active) e.currentTarget.style.backgroundColor = 'transparent'; }}
      >
        {active && <span className="absolute left-0 top-1/2 -translate-y-1/2 w-0.5 h-5 rounded-r" style={{ backgroundColor: 'var(--color-primary)' }} />}
        <span className="flex-shrink-0 relative">
          {item?.icon}
          {isNotifications && unreadCount > 0 && (
            <span className="absolute -top-1.5 -right-1.5 min-w-[16px] h-4 px-1 rounded-full flex items-center justify-center text-white font-bold" style={{ backgroundColor: 'var(--color-primary)', fontSize: '9px' }}>
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </span>
        {!collapsed && (
          <span className="text-sm font-medium whitespace-nowrap overflow-hidden flex-1" style={{ fontFamily: 'Inter, sans-serif' }}>
            {item?.label}
          </span>
        )}
        {!collapsed && isNotifications && unreadCount > 0 && (
          <span className="ml-auto min-w-[20px] h-5 px-1.5 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0" style={{ backgroundColor: 'var(--color-primary)', fontSize: '10px' }}>
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
        {collapsed && (
          <div className="absolute left-full ml-2 px-2 py-1 rounded text-xs text-white whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-50" style={{ backgroundColor: '#1a1a1a', border: '1px solid #2a2a2a' }}>
            {item?.label}
          </div>
        )}
      </button>
    );
  };

  return (
    <aside
      className="hidden md:flex flex-col h-screen sticky top-0 transition-all duration-300 border-r"
      style={{ width: collapsed ? '64px' : '220px', backgroundColor: '#0a0a0a', borderColor: '#1a1a1a', minWidth: collapsed ? '64px' : '220px' }}
    >
      <div className="flex items-center gap-3 px-4 py-5 border-b" style={{ borderColor: '#1a1a1a' }}>
        <img src="/logo-noirock.png" alt="NoiRock" className="flex-shrink-0 w-8 h-8 rounded-lg shadow-lg" />
        {!collapsed && (
          <span className="text-white font-bold text-base tracking-tight whitespace-nowrap overflow-hidden" style={{ fontFamily: 'Sora, sans-serif' }}>
            NoiRock
          </span>
        )}
        <button onClick={onToggle} className="ml-auto flex-shrink-0 w-6 h-6 flex items-center justify-center rounded text-white/30 hover:text-white/70 transition-colors">
          {collapsed ? (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M5 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
          ) : (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M9 3L5 7l4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
          )}
        </button>
      </div>
      <nav className="flex-1 py-3 overflow-y-auto overflow-x-hidden">
        {/* ── Main nav items ── */}
        {navItems?.map(renderItem)}

        {/* ── Region manager item ── */}
        {profile?.role === 'region_manager' && (
          <div
            onClick={() => navigate('/manager/region-performance')}
            className="w-full flex items-center gap-3 px-4 py-2.5 text-left transition-all duration-150 group relative cursor-pointer"
            style={{ backgroundColor: isActive('/manager/region-performance') ? 'rgba(229,32,42,0.08)' : 'transparent', color: isActive('/manager/region-performance') ? '#E5202A' : 'rgba(255,255,255,0.45)' }}
            onMouseEnter={(e) => { if (!isActive('/manager/region-performance')) e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.04)'; }}
            onMouseLeave={(e) => { if (!isActive('/manager/region-performance')) e.currentTarget.style.backgroundColor = 'transparent'; }}
          >
            <span>🌍</span>
            {!collapsed && <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', fontWeight: 500 }}>{t('nav.region')}</span>}
            {collapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 rounded text-xs text-white whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-50" style={{ backgroundColor: '#1a1a1a', border: '1px solid #2a2a2a' }}>
                {t('nav.region')}
              </div>
            )}
          </div>
        )}

        {/* ── Cashback item ── */}
        {profile?.is_paid && (
          <div
            onClick={() => navigate('/manager/cashback-payments')}
            className="w-full flex items-center gap-3 px-4 py-2.5 text-left transition-all duration-150 group relative cursor-pointer"
            style={{ backgroundColor: isActive('/manager/cashback-payments') ? 'rgba(229,32,42,0.08)' : 'transparent', color: isActive('/manager/cashback-payments') ? '#E5202A' : 'rgba(255,255,255,0.45)' }}
            onMouseEnter={(e) => { if (!isActive('/manager/cashback-payments')) e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.04)'; }}
            onMouseLeave={(e) => { if (!isActive('/manager/cashback-payments')) e.currentTarget.style.backgroundColor = 'transparent'; }}
          >
            <span>💰</span>
            {!collapsed && <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', fontWeight: 500 }}>{t('nav.cashback')}</span>}
            {collapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 rounded text-xs text-white whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-50" style={{ backgroundColor: '#1a1a1a', border: '1px solid #2a2a2a' }}>
                {t('nav.cashback')}
              </div>
            )}
          </div>
        )}

        {/* ── OUTILS section separator + items ── */}
        <div style={{ height: '1px', backgroundColor: 'rgba(255,255,255,0.06)', margin: '8px 16px' }} />
        {!collapsed && (
          <div style={{
            fontSize: '10px', fontWeight: '600',
            color: 'rgba(255,255,255,0.2)',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            padding: '8px 20px 4px',
            fontFamily: 'Sora, sans-serif',
          }}>
            {t('nav.tools')}
          </div>
        )}
        {toolsItems?.map(renderItem)}
      </nav>
      <div className="border-t p-3" style={{ borderColor: '#1a1a1a' }}>
        <button
          onClick={() => navigate('/manager/profile')}
          className="w-full flex items-center gap-2 px-2 py-2 rounded-lg mb-1 transition-colors"
          style={{ backgroundColor: 'transparent' }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.04)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
        >
          <div className="rounded-full flex items-center justify-center text-white font-bold flex-shrink-0" style={{ width: collapsed ? '32px' : '28px', height: collapsed ? '32px' : '28px', backgroundColor: 'var(--color-primary)', fontSize: '11px', fontFamily: 'Sora, sans-serif' }}>
            {getInitials(managerName)}
          </div>
          {!collapsed && managerName && (
            <p className="text-xs text-white/50 truncate flex-1 text-left" style={{ fontFamily: 'Inter, sans-serif' }}>{managerName}</p>
          )}
        </button>

        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-colors"
          style={{ backgroundColor: 'transparent', color: 'rgba(255,255,255,0.35)' }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.06)'; e.currentTarget.style.color = 'rgba(255,255,255,0.7)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = 'rgba(255,255,255,0.35)'; }}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="flex-shrink-0">
            <path d="M6 14H3a1 1 0 01-1-1V3a1 1 0 011-1h3M11 11l3-3-3-3M14 8H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          {!collapsed && <span className="text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>{t('nav.logout')}</span>}
        </button>
      </div>
    </aside>
  );
};

export default ManagerSidebar;
